import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export const SocialProofBanner = () => {
  return (
    <div className="flex w-full flex-col items-center gap-2">
      <StaticImage
        alt="social-proof-logos"
        height={200}
        src="../images/SocialProof.png"
      />
    </div>
  );
};
